import { render, staticRenderFns } from "./QuotaOverviewCard.vue?vue&type=template&id=9fda07a6"
import script from "./QuotaOverviewCard.vue?vue&type=script&lang=js"
export * from "./QuotaOverviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports